/* Min-qty guard for Seal Subscriptions */
(() => {
  const MIN = 2;
  const qs = (s, r = document) => r.querySelector(s);

  // ----- quantity -----
  function getQty() {
    const comp = qs('quantity-input');
    if (!comp) return 0;

    // Prefer internal input
    const input = comp.querySelector('input[name="quantity"]');
    if (input) {
      const v = input.value || input.getAttribute('value') || '0';
      return parseInt(v, 10) || 0;
    }

    // Fallback to component attrs
    const v = comp.value || comp.getAttribute('data-quantity') || comp.getAttribute('value') || '0';
    return parseInt(v, 10) || 0;
  }

  // ----- seal widget parts -----
  function getCtx() {
    const root = qs('.sls-purchase-options-container');
    if (!root) return null;

    const subs = qs('.sls-option-container[data-selling-plan-group]', root);
    const one  = qs('.sls-option-container:not([data-selling-plan-group])', root);

    return {
      root,
      subs,
      one,
      subsRadio: subs ? qs('input[type="radio"]', subs) : null,
      oneRadio : one  ? qs('input[type="radio"]',  one) : null,
      subsBtn  : subs ? qs('[role="button"]',     subs) : null,
      oneBtn   : one  ? qs('[role="button"]',     one)  : null,
      sellingInput: qs('input[type="hidden"][name="selling_plan"]', root)
    };
  }

  function forceOneTime(ctx) {
    if (!ctx) return;
    ctx.subs?.classList.remove('sls-active');
    ctx.subs?.classList.add('sls-disabled-by-min');
    ctx.subs?.setAttribute('aria-disabled', 'true');

    ctx.one?.classList.add('sls-active');
    if (ctx.subsRadio) { ctx.subsRadio.checked = false; ctx.subsRadio.disabled = true; }
    if (ctx.oneRadio)  { ctx.oneRadio.disabled  = false; ctx.oneRadio.checked = true; }
    ctx.oneRadio?.dispatchEvent(new Event('change', { bubbles: true }));
    ctx.oneBtn?.click();

    if (ctx.sellingInput) ctx.sellingInput.value = '';
  }

  function enableSubscribe(ctx) {
  if (!ctx) return;

  // Re-enable the Subscribe card
  ctx.subs?.classList.remove('sls-disabled-by-min');
  ctx.subs?.removeAttribute('aria-disabled');
  if (ctx.subsRadio) ctx.subsRadio.disabled = false;

  // If shopper already picked One-time, respect it
  if (ctx.oneRadio?.checked) return;

  // Otherwise, default to Subscribe & save
  if (!ctx.subsRadio?.checked) {
    ctx.subsRadio.checked = true;
    ctx.subsRadio.dispatchEvent(new Event('change', { bubbles: true }));
    ctx.subsBtn?.click(); // Seal listens for this and will update classes/UI
  }
}



  function ensureNote(ctx) {
    let note = document.getElementById('seal-min-qty-note');
    if (!note) {
      note = document.createElement('div');
      note.id = 'seal-min-qty-note';
      note.className = 'min-qty-helper';
      note.textContent = 'Add 2+ products to subscribe.';
      ctx.root.after(note);
    }
  }
  const removeNote = () => document.getElementById('seal-min-qty-note')?.remove();

  function update() {
    const ctx = getCtx();
    if (!ctx) return;

    if (getQty() < MIN) {
      forceOneTime(ctx);
      ensureNote(ctx);
    } else {
      enableSubscribe(ctx);
      removeNote();
    }
  }

  function hookQty() {
    const comp  = qs('quantity-input');
    const input = comp?.querySelector('input[name="quantity"]');
    if (!comp) return;

    // user interactions
    input?.addEventListener('input',  () => setTimeout(update, 0));
    input?.addEventListener('change', () => setTimeout(update, 0));
    comp.addEventListener('click', e => {
      if (e.target.closest('button')) setTimeout(update, 0); // plus/minus
    });

    // any DOM/attr updates
    new MutationObserver(() => update())
      .observe(comp, { attributes: true, childList: true, subtree: true });
  }

  function initWhenReady() {
    const root = qs('.sls-purchase-options-container');
    if (!root) { setTimeout(initWhenReady, 120); return; }

    update();
    hookQty();

    // seal can re-render; keep it in sync
    new MutationObserver(() => update())
      .observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', initWhenReady);
})();
